<script>
import { useAlert } from 'dashboard/composables';
import TeamForm from '../TeamForm.vue';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
// == Unichat Extension ==
import { addSectorTeam, getSectors } from 'dashboard/unichat/api/unichat.js';

export default {
  components: {
    TeamForm,
    PageHeader,
  },
  data() {
    return {
      enabledFeatures: {},
      // == Unichat Extension ==
      unichatSectors: [],
      unichatSelectedSectorId: '',
    };
  },
  // == Unichat Extension ==
  computed: {
    currentAccountId() {
      // Usa route params diretamente (mais confiável que o store getter no created())
      return Number(this.$route?.params?.accountId) || this.$store.getters.getCurrentAccountId;
    },
  },
  async created() {
    // == Unichat Extension: carrega secretarias disponíveis ==
    try {
      // eslint-disable-next-line no-console
      console.log('[Unichat] Carregando secretarias para account:', this.currentAccountId);
      const { data } = await getSectors(this.currentAccountId);
      this.unichatSectors = Array.isArray(data) ? data : (data?.payload ?? []);
      // eslint-disable-next-line no-console
      console.log('[Unichat] Secretarias carregadas:', this.unichatSectors.length, this.unichatSectors);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('[Unichat] Falha ao carregar secretarias:', err?.response?.status, err?.message);
    }
  },
  methods: {
    async createTeam(data) {
      try {
        const team = await this.$store.dispatch('teams/create', {
          ...data,
        });

        // == Unichat Extension: vincula o Setor à Secretaria selecionada ==
        if (this.unichatSelectedSectorId && team?.id) {
          try {
            await addSectorTeam(
              this.currentAccountId,
              this.unichatSelectedSectorId,
              team.id
            );
          } catch {
            // Falha silenciosa — o Time foi criado, apenas o vínculo não foi salvo
            useAlert('Setor criado! Mas não foi possível vincular à Secretaria. Tente vincular manualmente.');
          }
        }

        router.replace({
          name: 'settings_teams_add_agents',
          params: {
            page: 'new',
            teamId: team.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('TEAMS_SETTINGS.TEAM_FORM.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6 overflow-y-auto">
    <PageHeader
      :header-title="$t('TEAMS_SETTINGS.CREATE_FLOW.CREATE.TITLE')"
      :header-content="$t('TEAMS_SETTINGS.CREATE_FLOW.CREATE.DESC')"
    />
    <!-- == Unichat Extension: vínculo com Secretaria (acima do formulário) == -->
    <div class="mb-4 flex flex-col gap-1 w-full">
      <label class="text-sm font-medium text-n-slate-12">
        Secretaria <span class="text-n-slate-9 font-normal">(opcional)</span>
      </label>
      <p class="text-xs text-n-slate-9 mb-1">
        Vincule este Setor a uma Secretaria para organizar a hierarquia da prefeitura.
      </p>

      <!-- Sem secretarias cadastradas -->
      <div
        v-if="!unichatSectors.length"
        class="w-full rounded-lg border border-dashed border-n-weak bg-n-surface-2 px-3 py-2 text-sm text-n-slate-9"
      >
        Nenhuma secretaria cadastrada ainda.
        <a
          :href="`/app/accounts/${currentAccountId}/settings/unichat/sectors`"
          class="text-n-brand underline ml-1"
        >Criar secretaria</a>
      </div>

      <!-- Com secretarias disponíveis -->
      <select
        v-else
        v-model="unichatSelectedSectorId"
        class="w-full rounded-lg border border-n-weak bg-n-surface-1 px-3 py-2 text-sm text-n-slate-12 focus:outline-none focus:ring-2 focus:ring-n-brand"
      >
        <option value="">Nenhuma (criar sem vínculo)</option>
        <option
          v-for="sector in unichatSectors"
          :key="sector.id"
          :value="sector.id"
        >
          {{ sector.name }}
        </option>
      </select>
    </div>
    <!-- == /Unichat Extension == -->

    <div class="flex flex-wrap">
      <TeamForm
        :on-submit="createTeam"
        :submit-in-progress="false"
        :submit-button-text="$t('TEAMS_SETTINGS.FORM.SUBMIT_CREATE')"
      />
    </div>
  </div>
</template>
